import React from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';

import 'antd/dist/antd.css';

import PrivateRouter from './components/routes/private-route';
import Product from './pages/product';
import Login from './pages/login';
import BaseLayout from './components/base-layout/base';
import Category from './pages/category';
import CategoryDetail from './pages/category-detail';
import ProductInfo from './pages/product-information';
import Authenticate from './pages/authenticate';
import Logout from './pages/logout';
import NotFound from './pages/404';
import TemporaryRequests from './pages/temporary-requests';
import Transaction from './pages/transaction';
import Order from './pages/order';
import Customer from '@/pages/customer';
import CustomerInfoPage from '@/pages/customer-information';
import Tag from './pages/tag';
import TagInfo from './pages/tag-information';
import configs from './config';

function App() {
  return (
    <Router>
      <BaseLayout>
        <Switch>
          <Route path="/login" render={() => <Login />} />
          <Route path="/auth/redirect" render={() => <Authenticate />} />
          <Route path="/auth/logout" render={() => <Logout />} />

          {['category', 'all'].includes(configs.enabledComponents) && (
            <PrivateRouter
              path="/category/:id"
              exact
              render={(routeProps) => <CategoryDetail {...routeProps} />}
            />
          )}
          {['category', 'all'].includes(configs.enabledComponents) && (
            <PrivateRouter path="/category" render={() => <Category />} />
          )}
          {['product', 'all'].includes(configs.enabledComponents) && (
            <PrivateRouter
              path="/product/:id"
              exact
              render={(routeProps) => <ProductInfo {...routeProps} />}
            />
          )}
          {['product', 'all'].includes(configs.enabledComponents) && (
            <PrivateRouter path="/product" render={() => <Product />} />
          )}
          {['tag', 'all'].includes(configs.enabledComponents) && (
            <PrivateRouter
              path="/tag/:id"
              exact
              render={(routeProps) => <TagInfo {...routeProps} />}
            />
          )}
          {['tag', 'all'].includes(configs.enabledComponents) && (
            <PrivateRouter path="/tag" render={() => <Tag />} />
          )}
          {['all'].includes(configs.enabledComponents) && (
            <PrivateRouter path="/temporary-requests" render={() => <TemporaryRequests />} />
          )}
          {['all'].includes(configs.enabledComponents) && (
            <PrivateRouter path="/transactions" render={() => <Transaction />} />
          )}
          {['all'].includes(configs.enabledComponents) && (
            <PrivateRouter path="/orders" render={() => <Order />} />
          )}

          {['customer', 'all'].includes(configs.enabledComponents) && (
            <PrivateRouter
              path="/customer/:id"
              exact
              render={(routeProps) => <CustomerInfoPage {...routeProps} />}
            />
          )}
          {['customer', 'all'].includes(configs.enabledComponents) && (
            <PrivateRouter path="/customer" render={() => <Customer />} />
          )}
          <PrivateRouter
            exact
            path="/"
            render={() => (configs.ssoManagementOnly === 'true' ? <Customer /> : <Product />)}
          />
          <Route path="/404" component={NotFound} />
          <Redirect from="*" to="/404" />
        </Switch>
      </BaseLayout>
    </Router>
  );
}

export default App;
